// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination_main {
    margin: 10px;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    gap: 15px; 
}

.pagination_main ul {
    display: flex;
    justify-content: center;
    gap: 5px;
    align-items: center;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
}

.pagination_main ul li {
    list-style: none;
}

.pagination_main ul li a {
    background-color: #f1f5f9;
    color: #334155;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
    -webkit-user-select: none;
            user-select: none;
}

.pagination_main ul li a:hover {
    background-color: #e2e8f0;
}

.pagination_main ul li.selected a, .current_active {
    background-color: #105293 !important;
    color: white !important;
    border-color: #105293;
}

.pagination_main ul li.disabled a {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f1f5f9 !important;
    color: #94a3b8 !important;
    border-color: #e2e8f0 !important;
}

/* Jump to page styling */
.pagination_jump {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #475569;
}

.pagination_jump input {
    width: 60px;
    padding: 6px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    text-align: center;
    outline: none;
}

.pagination_jump input:focus {
    border-color: #105293;
}

.pagination_jump button {
    background-color: #105293;
    color: white;
    border: none;
    padding: 6.5px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s ease;
}

.pagination_jump button:hover {
    background-color: #0d4275;
}

@media screen and (max-width: 576px) {
    .pagination_main {
        flex-direction: column;
        gap: 10px;
    }
    .pagination_main ul li a {
        padding: 6px 10px;
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Paginated/pagination.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":[".pagination_main {\n    margin: 10px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    align-items: center;\n    gap: 15px; \n}\n\n.pagination_main ul {\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    flex-wrap: wrap;\n}\n\n.pagination_main ul li {\n    list-style: none;\n}\n\n.pagination_main ul li a {\n    background-color: #f1f5f9;\n    color: #334155;\n    font-weight: 600;\n    border-radius: 8px;\n    padding: 8px 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    border: 1px solid #e2e8f0;\n    transition: all 0.2s ease;\n    user-select: none;\n}\n\n.pagination_main ul li a:hover {\n    background-color: #e2e8f0;\n}\n\n.pagination_main ul li.selected a, .current_active {\n    background-color: #105293 !important;\n    color: white !important;\n    border-color: #105293;\n}\n\n.pagination_main ul li.disabled a {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: #f1f5f9 !important;\n    color: #94a3b8 !important;\n    border-color: #e2e8f0 !important;\n}\n\n/* Jump to page styling */\n.pagination_jump {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #475569;\n}\n\n.pagination_jump input {\n    width: 60px;\n    padding: 6px 10px;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    text-align: center;\n    outline: none;\n}\n\n.pagination_jump input:focus {\n    border-color: #105293;\n}\n\n.pagination_jump button {\n    background-color: #105293;\n    color: white;\n    border: none;\n    padding: 6.5px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n}\n\n.pagination_jump button:hover {\n    background-color: #0d4275;\n}\n\n@media screen and (max-width: 576px) {\n    .pagination_main {\n        flex-direction: column;\n        gap: 10px;\n    }\n    .pagination_main ul li a {\n        padding: 6px 10px;\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
